// Operational cost settings dialog.
import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Settings as SettingsIcon } from "lucide-react";
import { getSettings, updateSettings } from "@/lib/analytics";

const FIELDS = [
  { key: "shipping_cost", label: "Cost livrare", suffix: "RON / comandă", hint: "Estimare per comandă expediată" },
  { key: "packaging_cost", label: "Cost ambalare", suffix: "RON / comandă", hint: "Material consumabil + manoperă" },
  { key: "return_cost", label: "Cost retur", suffix: "RON / retur", hint: "Curier + procesare retur" },
  { key: "tax_rate", label: "TVA / Impozit", suffix: "%", hint: "Rata de impozit aplicată pe venit" },
];

export default function SettingsDialog({ onChanged, trigger }) {
  const [open, setOpen] = useState(false);
  const [vals, setVals] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) getSettings().then(setVals).catch(() => {});
  }, [open]);

  const save = async () => {
    setBusy(true);
    try {
      const out = await updateSettings(vals);
      setVals(out);
      toast.success("Setări salvate");
      onChanged?.();
      setOpen(false);
    } catch { toast.error("Eroare la salvare"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="outline" size="sm" className="h-9" data-testid="analytics-settings-btn">
            <SettingsIcon className="h-3.5 w-3.5 mr-1.5" /> Setări costuri
          </Button>
        )}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Costuri operaționale</DialogTitle>
          <DialogDescription>Valorile folosite în calculul profitului real. Modificările se aplică retroactiv tuturor analizelor.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {FIELDS.map((f) => (
            <div key={f.key} className="flex items-end gap-2">
              <div className="flex-1">
                <label className="text-[11px] text-muted-foreground">{f.label}</label>
                <Input
                  type="number" min="0" step="0.1"
                  value={vals[f.key] ?? ""}
                  onChange={(e) => setVals({ ...vals, [f.key]: e.target.value })}
                  data-testid={`analytics-setting-${f.key}`}
                />
                <div className="text-[10px] text-muted-foreground mt-1">{f.hint}</div>
              </div>
              <div className="text-xs text-muted-foreground pb-2 whitespace-nowrap">{f.suffix}</div>
            </div>
          ))}
          <Button onClick={save} disabled={busy} className="w-full" data-testid="analytics-settings-save">
            Salvează
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
